// Redirect Actions
export const REDIRECT_TO_LOGIN = 'REDIRECT_TO_LOGIN';
export const REDIRECT_COMPLETED = 'REDIRECT_COMPLETED';
export const CLEAR_AUTH_DATA = 'CLEAR_AUTH_DATA';
export const LOGOUT_AND_REDIRECT = 'LOGOUT_AND_REDIRECT';

// Action Creators
export const redirectToLogin = (pathname, navigate, reason = 'token_expired') => ({
  type: REDIRECT_TO_LOGIN,
  payload: { pathname, navigate, reason }
});

export const redirectCompleted = (redirectedTo, from, reason) => ({
  type: REDIRECT_COMPLETED,
  payload: { redirectedTo, from, reason }
});

export const clearAuthData = () => ({
  type: CLEAR_AUTH_DATA,
  payload: { clearedAt: new Date().toISOString() }
});

export const logoutAndRedirect = (pathname, navigate, reason = 'manual_logout') => ({
  type: LOGOUT_AND_REDIRECT,
  payload: { pathname, navigate, reason }
});
